import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const ScrollRestoration = ({ scrollRef }) => {
  const location = useLocation();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
  }, [location.pathname, scrollRef]);

  return null;
};

ScrollRestoration.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.any,
  }).isRequired,
};

export default ScrollRestoration;

